import type { PropsWithChildren } from "react";
import { useEffect } from "react";

import { useSessionStore } from "@/entities/session";
import { Theme } from "@/entities/session/types";

export const ThemeLayout = ({ children }: PropsWithChildren) => {
  const { theme } = useSessionStore();
  useEffect(() => {
    const body = document.documentElement;
    body.classList.remove(Theme.Light, Theme.Dark);
    body.classList.add(theme);
  }, [theme]);

  return children;
};
